import { DatasetType } from '@/types/automationFields.ts';

import ExcelIcon from '@/assets/dataset_icons/Excel.svg?url';
import CsvIcon from '@/assets/dataset_icons/CSV.svg?url';
import WordIcon from '@/assets/dataset_icons/Word.svg?url';
import PowerPointIcon from '@/assets/dataset_icons/PPT.svg?url';
import ImageIcon from '@/assets/dataset_icons/IMAGE.svg?url';
import TextFileIcon from '@/assets/dataset_icons/TXT.svg?url';
import MarkdownIcon from '@/assets/dataset_icons/Markdown.svg?url';
import GenericFileIcon from '@/assets/dataset_icons/FILE.svg?url';
import FolderIcon from '@/assets/dataset_icons/FOLDER.svg?url';
import VideoIcon from '@/assets/dataset_icons/VIDEO.svg?url';

import HtmlFileIcon from '@/assets/dataset_icons/HTML & XML.svg?url';
import PdfIcon from '@/assets/dataset_icons/PDF.svg?url';
import JsonFileIcon from '@/assets/dataset_icons/JSON.svg?url';
import { isDirectory } from '@/utils/datasetTypes.ts';
import {
  ODS_CONTENT_TYPE,
  SPREADSHEET_WORKBOOK_MIME_TYPES,
} from '@/utils/mimeTypes.ts';
import { Dataset } from '@/types/datasets.ts';

export const datasetToFileTypeAndIcon = (dataset: Dataset) => {
  const [fileType, icon] = _datasetToFileTypeAndIcon(dataset);
  return { fileType: fileType, icon: icon };
};

export const _datasetToFileTypeAndIcon = (dataset: Dataset) => {
  if (isDirectory(dataset)) {
    return ['Folder', FolderIcon];
  }

  let mime = dataset.original_mime_type;
  if (!mime) {
    if (dataset.dataset_type === DatasetType.File) {
      mime = 'text/plain';
    } else if (dataset.dataset_type === DatasetType.Dataframe) {
      mime = 'text/csv';
    } else if (dataset.dataset_type === DatasetType.Json) {
      mime = 'application/json';
    }
  }

  if (!mime) {
    return ['Unknown File', GenericFileIcon];
  }

  if (SPREADSHEET_WORKBOOK_MIME_TYPES.includes(mime)) {
    if (mime === ODS_CONTENT_TYPE) {
      return ['OpenDocument Spreadsheet', ExcelIcon];
    }
    return ['Excel Spreadsheet', ExcelIcon];
  }
  if (
    [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ].includes(mime)
  ) {
    return ['Word Document', WordIcon];
  }
  if (
    [
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ].includes(mime)
  ) {
    return ['PowerPoint Presentation', PowerPointIcon];
  }
  if (['image/png', 'image/jpeg', 'image/gif'].includes(mime)) {
    return ['Image', ImageIcon];
  }
  if (mime === 'video/mp4') {
    return ['Video', VideoIcon];
  }
  if (mime === 'text/plain') {
    return ['Text File', TextFileIcon];
  }
  if (mime === 'text/markdown') {
    return ['Markdown File', MarkdownIcon];
  }
  if (mime === 'text/html') {
    return ['HTML File', HtmlFileIcon];
  }
  if (mime === 'text/xml') {
    return ['XML File', HtmlFileIcon];
  }
  if (mime === 'text/csv' || mime === 'application/csv') {
    return ['CSV File', CsvIcon];
  }
  if (mime === 'application/json') {
    return ['JSON File', JsonFileIcon];
  }
  if (mime === 'application/pdf') {
    return ['PDF Document', PdfIcon];
  }
  if (mime === 'application/zip') {
    return ['ZIP Archive', FolderIcon];
  }
  if (mime === 'application/vnd.google-apps.folder') {
    return ['Google Drive Folder', FolderIcon];
  }
  if (mime === 'application/vnd.google-apps.document') {
    return ['Google Doc', WordIcon];
  }
  if (mime === 'application/vnd.google-apps.spreadsheet') {
    return ['Google Sheet', ExcelIcon];
  }
  return ['Unknown File', GenericFileIcon];
};
